import { Fragment } from "react";
import { Header, Footer, MenuSidebar, ContactModel } from "../index";
import ProjectDd from "../projectDd/ProjectDd";

const PageLayout = ({ children }) => {
  return (
    <Fragment>
        <MenuSidebar />
        <ProjectDd />
        <Header />
        <ContactModel />
        {children}
        <Footer />
    </Fragment>
  );
};

export default PageLayout;
